import React from "react";

import HeroSection from "../Components/home/HeroSection";
import PainPointsSection from "../Components/home/PainPointsSection";
import BenefitsSection from "../Components/home/BenefitsSection";
import SetupStepsSection from "../Components/home/SetupStepsSection";
import ProductSeriesSection from "../Components/home/ProductSeriesSection";
import UseCasesSection from "../Components/home/UseCasesSection";
import TrustSection from "../Components/home/TrustSection";
import ConversionSection from "../Components/home/ConversionSection";
import Reveal from "../Components/home/Reveal";

export default function KylendarOverview() {
  return (
    <main className="home-paper overflow-hidden text-slate-900">
      <HeroSection />
      <Reveal><PainPointsSection /></Reveal>
      <Reveal><BenefitsSection /></Reveal>
      <Reveal><SetupStepsSection /></Reveal>
      <Reveal><ProductSeriesSection /></Reveal>
      <Reveal><UseCasesSection /></Reveal>
      <Reveal><TrustSection /></Reveal>
      <Reveal><ConversionSection /></Reveal>
    </main>
  );
}
